import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response } from '@angular/http';

import { environment } from '../../environments/environment';
const config = environment.config;

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { User } from './user';

// Http service to perform login operation
// import this to your login.component and use signIn() to log user in

@Injectable()
export class HttpAuthenticationService {

	private authUrl = config.API_BASE_URL + '/user';

	constructor(private http: HttpClient) {}

	signIn(user: any): Observable < any > {

		return this.http.post(this.authUrl + '/login', user)
			.map(this.extractData)
			.catch(this.handleError);
	}

	getSignedInUser(): Observable < any > {
		return this.http.get(this.authUrl + '/authUser')
			.map(this.extractData)
			.catch(this.handleError);
	}

	updateUserInfos(user: User): Observable < User > {
		return this.http.put(this.authUrl, user)
			.map(this.extractData)
			.catch(this.handleError);
	}

	getSignedAuthorizationLevel(): Observable < number > {
		return this.http.get(this.authUrl + '/authUserLevel')
			.map(this.extractData)
			.catch(this.handleError);
	}

	renewAuth(): Observable < any > {
		return this.http.get(this.authUrl + '/renewAuth')
			.map(this.extractData)
			.catch(this.handleError);
	}

	private extractData(res: Response) {
		
		return res['data'] || {};
	}

	private handleError(error: Response | any) {

		return Observable.throw(error.error);
	}
}


// WEBPACK FOOTER //
// ./src/app/authentication/http-authentication.service.ts